
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as accountOFWlhQvpMKcUAKhyvFYjSLO3GmybVKm_0EULi202OU4Meta } from "/app/packages/client/app/pages/user/funds/account.vue?macro=true";
import { default as detailrxN7borYENtTZb3cBXdu79ynvsreMcmj75rMuvAsvpUMeta } from "/app/packages/client/app/pages/user/funds/detail.vue?macro=true";
import { default as rechargeJzPRLRt4umR7XeiPBYLmha648AEKrVPW_ox2Ws68JukMeta } from "/app/packages/client/app/pages/user/funds/recharge.vue?macro=true";
import { default as taskRnT5mszZZSsslkes1zot2XlSK_N_vmWv583Xe_zAytYMeta } from "/app/packages/client/app/pages/user/order/task.vue?macro=true";
import { default as detailP4w_mQDrZ_y_wEhOWwy6FSncciIbEaPXWCGJvEZtn_gMeta } from "/app/packages/client/app/pages/user/task/detail.vue?macro=true";
import { default as releasevA6YbfA87MT4hVK1e9pYjI7I2h6LnofIHQwxeDJlDw0Meta } from "/app/packages/client/app/pages/user/task/release.vue?macro=true";
import { default as _91id_93oagw8ro87ix3q9fNC9MQcqr7DLnVO0y4i0PgWvxQOXEMeta } from "/app/packages/client/app/pages/news/detail/[id].vue?macro=true";
import { default as _91id_93oQAMerFY5cv6YVudNBKrcYZJ6qfxKnsNVIVusXhQT9gMeta } from "/app/packages/client/app/pages/news/type/[id].vue?macro=true";
import { default as agreementHVaACwvhrRXe2VRHFLdkt4BEAg0yeDpqqWyPTlLyszQMeta } from "/app/packages/client/app/pages/mobile/agreement.vue?macro=true";
import { default as registerbvLhnsm_LgoDz_FHc4ZNJazv75JIfEeGJKUOB_EOvKMMeta } from "/app/packages/client/app/pages/mobile/register.vue?macro=true";
import { default as index2OREiDYPuHSlMEZwAka0DOrm2CA_UEo_vxJ6K7z_WvYMeta } from "/app/packages/client/app/pages/news/detail/index.vue?macro=true";
import { default as indexHxsmRP4hA8Dv3eXjSm4Ut3SQAdj0HJ5eX1BueLV1oEMMeta } from "/app/packages/client/app/pages/news/type/index.vue?macro=true";
import { default as accountPSYd3H9EsO6z_ZB_rxtf_ldlVgJgH0TD7ydPp96_MSoMeta } from "/app/packages/client/app/pages/user/account.vue?macro=true";
import { default as aftersales4d1sjs7HCqNs_nucLlQ0gLddgoqwXIb0FOcYcI9txwQMeta } from "/app/packages/client/app/pages/user/aftersales.vue?macro=true";
import { default as apioL8xARIMlcnFdL85ZTArtpEjTOxXEWZC1K5REBep9h4Meta } from "/app/packages/client/app/pages/user/api.vue?macro=true";
import { default as authW2s02oUAJqD3Xfa52d28syXgYNiHQ5B4T0eiZ4DxO0YMeta } from "/app/packages/client/app/pages/user/auth.vue?macro=true";
import { default as directomvjsfXnhaGQOUakzhNjM_eMb_shmkQT69Zzik0k53IMeta } from "/app/packages/client/app/pages/user/direct.vue?macro=true";
import { default as exportDBCj7OYH1YeAtO8svskaUjvh6Ji_8vN1ONwVrf2CjN0Meta } from "/app/packages/client/app/pages/user/export.vue?macro=true";
import { default as feedbackDeKl81jen4QFdt1V9SYuhllQ1B_XxdwzgvlUlFXBEKkMeta } from "/app/packages/client/app/pages/user/feedback.vue?macro=true";
import { default as indexTkA79rwuvIeFOs_YrmGiFajFrDzCtSp7_oWicUlP7gUMeta } from "/app/packages/client/app/pages/user/funds/index.vue?macro=true";
import { default as informationbz9rT0d30j3beYrDx2fM8LaXwBUXpsOdZEQyaSl5nWUMeta } from "/app/packages/client/app/pages/user/information.vue?macro=true";
import { default as managements3kRRruyaZsy_0ueQkb_Fmqy6P4V4VfSonZgidLaOEoMeta } from "/app/packages/client/app/pages/user/management.vue?macro=true";
import { default as index3btm42CrWmeycq54hSbuTzc_hW0FK196CuP9vkUZzRcMeta } from "/app/packages/client/app/pages/user/order/index.vue?macro=true";
import { default as statistics7bwmTSA89Gf5x8jVHjP4UU3hlf3D8xGn3KxqtesY8wAMeta } from "/app/packages/client/app/pages/user/statistics.vue?macro=true";
import { default as indexVVBm689OinYdkqTmCFEZOra0WPv_W7Z7INKoLW9sNOMMeta } from "/app/packages/client/app/pages/user/task/index.vue?macro=true";
import { default as wechat_45callbackaArViGXkZvSFGWzuF_1MZwCN8VZnxYAxleytqt3DmkgMeta } from "/app/packages/client/app/pages/user/wechat-callback.vue?macro=true";
import { default as withdrawalBdkopGPztKZL8IZd5Q1nwZYsXlGxfqtUhMYrpxUQIcwMeta } from "/app/packages/client/app/pages/user/withdrawal.vue?macro=true";
import { default as _91id_938rR3qRSB3iFkAPTQr0qFzSf7tE47lepD84tsDcQA9uoMeta } from "/app/packages/client/app/pages/notice/[id].vue?macro=true";
import { default as downloadwvo_Ge_Shf_coTDYORb3nhXavmh_ewyXunaxI_15fTAMeta } from "/app/packages/client/app/pages/download.vue?macro=true";
import { default as loginFOaugP35te9Mn4mR5OKGG2f8kwKhu4InQc_HawwNTToMeta } from "/app/packages/client/app/pages/login.vue?macro=true";
import { default as index21Bha9jR2IPMOZRktmK9MZ2HM5_IK6nTN9C7dsztFagMeta } from "/app/packages/client/app/pages/news/index.vue?macro=true";
import { default as indexXi3PnYM3J8Gqv8XrRWmeXVrvxpVa22O7TdXjkl2WCyEMeta } from "/app/packages/client/app/pages/notice/index.vue?macro=true";
import { default as indexHq_QhmqNHyPB99DZLtv_A4qj5bHOi6DWEdlpftS4VBYMeta } from "/app/packages/client/app/pages/user/index.vue?macro=true";
import { default as indexzOLzWboj8xyFk3JHWKLlU2X2w30lJNCXfPLFWvyAhhcMeta } from "/app/packages/client/app/pages/index.vue?macro=true";
export default [
  {
    name: "user-funds-account",
    path: "/user/funds/account",
    meta: accountOFWlhQvpMKcUAKhyvFYjSLO3GmybVKm_0EULi202OU4Meta || {},
    component: () => import("/app/packages/client/app/pages/user/funds/account.vue")
  },
  {
    name: "user-funds-detail",
    path: "/user/funds/detail",
    meta: detailrxN7borYENtTZb3cBXdu79ynvsreMcmj75rMuvAsvpUMeta || {},
    component: () => import("/app/packages/client/app/pages/user/funds/detail.vue")
  },
  {
    name: "user-funds-recharge",
    path: "/user/funds/recharge",
    meta: rechargeJzPRLRt4umR7XeiPBYLmha648AEKrVPW_ox2Ws68JukMeta || {},
    component: () => import("/app/packages/client/app/pages/user/funds/recharge.vue")
  },
  {
    name: "user-order-task",
    path: "/user/order/task",
    meta: taskRnT5mszZZSsslkes1zot2XlSK_N_vmWv583Xe_zAytYMeta || {},
    component: () => import("/app/packages/client/app/pages/user/order/task.vue")
  },
  {
    name: "user-task-detail",
    path: "/user/task/detail",
    meta: detailP4w_mQDrZ_y_wEhOWwy6FSncciIbEaPXWCGJvEZtn_gMeta || {},
    component: () => import("/app/packages/client/app/pages/user/task/detail.vue")
  },
  {
    name: "user-task-release",
    path: "/user/task/release",
    meta: releasevA6YbfA87MT4hVK1e9pYjI7I2h6LnofIHQwxeDJlDw0Meta || {},
    component: () => import("/app/packages/client/app/pages/user/task/release.vue")
  },
  {
    name: "news-detail-id",
    path: "/news/detail/:id()",
    component: () => import("/app/packages/client/app/pages/news/detail/[id].vue")
  },
  {
    name: "news-type-id",
    path: "/news/type/:id()",
    component: () => import("/app/packages/client/app/pages/news/type/[id].vue")
  },
  {
    name: "mobile-agreement",
    path: "/mobile/agreement",
    meta: agreementHVaACwvhrRXe2VRHFLdkt4BEAg0yeDpqqWyPTlLyszQMeta || {},
    component: () => import("/app/packages/client/app/pages/mobile/agreement.vue")
  },
  {
    name: "mobile-register",
    path: "/mobile/register",
    meta: registerbvLhnsm_LgoDz_FHc4ZNJazv75JIfEeGJKUOB_EOvKMMeta || {},
    component: () => import("/app/packages/client/app/pages/mobile/register.vue")
  },
  {
    name: "news-detail",
    path: "/news/detail",
    component: () => import("/app/packages/client/app/pages/news/detail/index.vue")
  },
  {
    name: "news-type",
    path: "/news/type",
    component: () => import("/app/packages/client/app/pages/news/type/index.vue")
  },
  {
    name: "user-account",
    path: "/user/account",
    meta: accountPSYd3H9EsO6z_ZB_rxtf_ldlVgJgH0TD7ydPp96_MSoMeta || {},
    component: () => import("/app/packages/client/app/pages/user/account.vue")
  },
  {
    name: "user-aftersales",
    path: "/user/aftersales",
    meta: aftersales4d1sjs7HCqNs_nucLlQ0gLddgoqwXIb0FOcYcI9txwQMeta || {},
    component: () => import("/app/packages/client/app/pages/user/aftersales.vue")
  },
  {
    name: "user-api",
    path: "/user/api",
    meta: apioL8xARIMlcnFdL85ZTArtpEjTOxXEWZC1K5REBep9h4Meta || {},
    component: () => import("/app/packages/client/app/pages/user/api.vue")
  },
  {
    name: "user-auth",
    path: "/user/auth",
    meta: authW2s02oUAJqD3Xfa52d28syXgYNiHQ5B4T0eiZ4DxO0YMeta || {},
    component: () => import("/app/packages/client/app/pages/user/auth.vue")
  },
  {
    name: "user-direct",
    path: "/user/direct",
    meta: directomvjsfXnhaGQOUakzhNjM_eMb_shmkQT69Zzik0k53IMeta || {},
    component: () => import("/app/packages/client/app/pages/user/direct.vue")
  },
  {
    name: "user-export",
    path: "/user/export",
    meta: exportDBCj7OYH1YeAtO8svskaUjvh6Ji_8vN1ONwVrf2CjN0Meta || {},
    component: () => import("/app/packages/client/app/pages/user/export.vue")
  },
  {
    name: "user-feedback",
    path: "/user/feedback",
    meta: feedbackDeKl81jen4QFdt1V9SYuhllQ1B_XxdwzgvlUlFXBEKkMeta || {},
    component: () => import("/app/packages/client/app/pages/user/feedback.vue")
  },
  {
    name: "user-funds",
    path: "/user/funds",
    meta: indexTkA79rwuvIeFOs_YrmGiFajFrDzCtSp7_oWicUlP7gUMeta || {},
    component: () => import("/app/packages/client/app/pages/user/funds/index.vue")
  },
  {
    name: "user-information",
    path: "/user/information",
    meta: informationbz9rT0d30j3beYrDx2fM8LaXwBUXpsOdZEQyaSl5nWUMeta || {},
    component: () => import("/app/packages/client/app/pages/user/information.vue")
  },
  {
    name: "user-management",
    path: "/user/management",
    meta: managements3kRRruyaZsy_0ueQkb_Fmqy6P4V4VfSonZgidLaOEoMeta || {},
    component: () => import("/app/packages/client/app/pages/user/management.vue")
  },
  {
    name: "user-order",
    path: "/user/order",
    meta: index3btm42CrWmeycq54hSbuTzc_hW0FK196CuP9vkUZzRcMeta || {},
    component: () => import("/app/packages/client/app/pages/user/order/index.vue")
  },
  {
    name: "user-statistics",
    path: "/user/statistics",
    meta: statistics7bwmTSA89Gf5x8jVHjP4UU3hlf3D8xGn3KxqtesY8wAMeta || {},
    component: () => import("/app/packages/client/app/pages/user/statistics.vue")
  },
  {
    name: "user-task",
    path: "/user/task",
    meta: indexVVBm689OinYdkqTmCFEZOra0WPv_W7Z7INKoLW9sNOMMeta || {},
    component: () => import("/app/packages/client/app/pages/user/task/index.vue")
  },
  {
    name: "user-wechat-callback",
    path: "/user/wechat-callback",
    meta: wechat_45callbackaArViGXkZvSFGWzuF_1MZwCN8VZnxYAxleytqt3DmkgMeta || {},
    component: () => import("/app/packages/client/app/pages/user/wechat-callback.vue")
  },
  {
    name: "user-withdrawal",
    path: "/user/withdrawal",
    meta: withdrawalBdkopGPztKZL8IZd5Q1nwZYsXlGxfqtUhMYrpxUQIcwMeta || {},
    component: () => import("/app/packages/client/app/pages/user/withdrawal.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/app/packages/client/app/pages/notice/[id].vue")
  },
  {
    name: "download",
    path: "/download",
    component: () => import("/app/packages/client/app/pages/download.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginFOaugP35te9Mn4mR5OKGG2f8kwKhu4InQc_HawwNTToMeta || {},
    component: () => import("/app/packages/client/app/pages/login.vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/app/packages/client/app/pages/news/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    component: () => import("/app/packages/client/app/pages/notice/index.vue")
  },
  {
    name: "user",
    path: "/user",
    meta: indexHq_QhmqNHyPB99DZLtv_A4qj5bHOi6DWEdlpftS4VBYMeta || {},
    component: () => import("/app/packages/client/app/pages/user/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/packages/client/app/pages/index.vue")
  }
]